
const services = [
    {
        "id": 1,
        title: "Logo Designing",
        description: "Create a powerful first impression with a unique and memorable logo that encapsulates your brand's essence."
    },
    {
        "id": 2,
        title: "Web Designing", 
        description: "Create a lasting digital impression with websites designed to immerse visitors in an intuitive and visually captivating online journey."
    },  
    {
        "id": 3,
        title: "Web Hosting", 
        description: "Ensure uninterrupted online presence with our dependable web hosting solutions, offering swift loading, secure data management, and round-the-clock support."
    },  
    {
        "id": 4,
        title: "Content Writing", 
        description: "Harness the power of impactful communication with our skilled content writers who craft compelling narratives across blogs, websites, and more."
    },  
    {
        "id": 5,
        title: "Web Development", 
        description: "Turn your digital dreams into reality with our web development expertise, creating functional, aesthetically pleasing websites that align with your objectives."
    },  
    {
        "id": 6,
        title: "Social Media Handling", 
        description: "Effortlessly navigate the dynamic social media landscape as we curate, schedule, and manage content to foster engagement and extend your brand's outreach."
    }, 
]

export default services;